import { format } from '@seek/currency';

import { LANGUAGE_LOCALE_DEFAULT } from 'src/app/shared/constants/language';
import { isPositiveNumber } from 'src/app/utils/isPositiveNumber';

export const getPayRange = ({
  min,
  max,
  currency,
  locale = LANGUAGE_LOCALE_DEFAULT,
}: {
  min?: number;
  max?: number;
  currency: string;
  locale?: string;
}): string | null => {
  const display = 'code';
  const dropFraction = true;

  const isValidMin = isPositiveNumber(min);
  const isValidMax = isPositiveNumber(max);
  const formattedMin = isValidMin
    ? format(min, { display, dropFraction, currency, locale })
    : null;
  const formattedMax = isValidMax
    ? format(max, { display, dropFraction, currency, locale })
    : null;

  if (isValidMin && isValidMax) {
    return min === max
      ? `${formattedMin}`
      : `${formattedMin} – ${formattedMax}`;
  }
  return formattedMin ?? formattedMax;
};
